import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

const Option = (props) => (
    <MenuItem
        buttonRef={props.innerRef}
        selected={props.isFocused}
        component="div"
        style={{
            fontWeight: props.isSelected ? 500 : 400
        }}
        {...props.innerProps}
    >
        {props.children}
    </MenuItem>
);

const inputComponent = ({inputRef, ...props}) => (
    <div ref={inputRef} {...props} />
);

const Control = (props) => (
    <TextField
        fullWidth
        InputProps={{
            inputComponent,
            inputProps: {
                className: props.selectProps.classes.input,
                inputRef: props.innerRef,
                children: props.children,
                ...props.innerProps
            }
        }}
        {...props.selectProps.textFieldProps}
    />
);

const NoOptionsMessage = (props) => (
    <Typography
        color="textSecondary"
        className={props.selectProps.classes.noOptionsMessage}
        {...props.innerProps}
    >
        {props.children}
    </Typography>
);

const Placeholder = (props) => (
    <Typography
        color="textSecondary"
        className={props.selectProps.classes.placeholder}
        {...props.innerProps}
    >
        {props.children}
    </Typography>
);

const SingleValue = (props) => (
    <Typography
        className={props.selectProps.classes.singleValue}
        {...props.innerProps}
    >
        {props.children}
    </Typography>
);

const ValueContainer = (props) => (
    <div
        className={props.selectProps.classes.valueContainer}
    >
        {props.children}
    </div>
);

const Menu = (props) => (
    <Paper
        square
        className={props.selectProps.classes.paper}
        {...props.innerProps}
    >
        {props.children}
    </Paper>
);

const components = {
    Option,
    Control,
    NoOptionsMessage,
    Placeholder,
    SingleValue,
    ValueContainer,
    Menu,
};

const style = (theme) => ({
    input: {
        display: 'flex',
        //padding: 0,
    },
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
    },
    noOptionsMessage: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
    singleValue: {
        fontSize: 16,
    },
    placeholder: {
        position: 'absolute',
        left: 2,
        fontSize: 16,
    },
    paper: {
        marginTop: theme.spacing(1),
    },
});

const AutoComplete = props => {
    const suggestions = props.options.map((option) => ({
        value: option[props.valueProp],
        label: option[props.labelProp]
    }));

    const selectStyles = {
        input: base => ({
            ...base,
            color: props.theme.palette.text.primary,
        }),
    };

    const handleOnKeyUp = (event) => {
        props.onSearch(event.target.value);
    };

    const value = () => {
        if (props.value) {
            return {
                value: props.value[props.valueProp],
                label: props.value[props.labelProp],
            }
        } else {
            return {};
        }
    };

    return (
        <Select
            classes={props.classes}
            styles={selectStyles}
            components={components}
            options={suggestions}
            value={value()}
            onChange={props.onChange}
            isDisabled={props.readOnly}
            textFieldProps={{
                name: 'owner',
                label: props.label,
                onKeyUp: handleOnKeyUp,
                InputLabelProps: {
                    shrink: true,
                },
            }}
        />
    );
};

AutoComplete.propTypes = {
    options: PropTypes.arrayOf(PropTypes.any),
    value: PropTypes.shape(),
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func,
    placeholder: PropTypes.string,
    valueProp: PropTypes.string,
    labelProp: PropTypes.string,
    readOnly: PropTypes.bool,
};

AutoComplete.defaultProps = {
    placeholder: '',
    readOnly: false,
};

export default withStyles(style, {withTheme: true})(AutoComplete);
